import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './ideiaNegocioForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import ContentCardFooter from '../common/template/contentCardFooter';
import Background from '../common/template/background';
import DateFormat from '../common/dateFormat/DateFormat';
import imagemFundo from '../assets/images/ideiaNegocio/fundo.png';

import { setModoTela, initForm, salvar, excluir, getLista } from './ideiaNegocioActions';
import { getLista as getListaTexto } from '../texto/textoActions';
import TextoInput from '../texto/textoInput';

class AdmIdeiaNegocio extends Component {

	state = {
		linhaSelecionada: null
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaTexto();
    }

    render() {
        return (
            <Background
				backgroundPosition={'bottom 100px'}
				gradientStart='#ffffff'
				gradientEnd='#ffffff'>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'visualizacao' ? (
						<Form visualizacao onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </Background>
        )
    }

	lista() {

		let lista = this.props.lista.filter(item => {
			if (this.state.pesquisar
				&& !(`${item.nome} ${DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)} 
					${item.nome_usuario} ${item.nome_projeto} ${item.email} ${item.celular} 
					${item.endereco}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		});

		return (
			<ContentCard>
				<ContentCardHeader>
					
					<h3 style={{ color: '#0F2748', textAlign: 'center', fontWeight: 'bold' }}>IDEIAS DE NEGÓCIO</h3>
				
				</ContentCardHeader>
				<ContentCardBody>

					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value, paginacaoIndice: 0 });
						}} />
				
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Data</Th>
								<Th alignCenter>Empreendedor</Th>
								<Th alignCenter>Nome do Projeto</Th>
								<Th alignCenter>E-mail</Th>
								<Th alignCenter>Telefone</Th>
								<Th alignCenter>Endereço</Th>
								<Th alignCenter></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)}</Td>
									<Td alignCenter>{item.nome_usuario}</Td>
									<Td alignCenter>{item.nome_projeto}</Td>
									<Td alignCenter>{item.email}</Td>
									<Td alignCenter>{item.celular}</Td>
									<Td alignCenter>{item.endereco}</Td>
									<Td alignRight minWidth={100}>																			
										<ButtonTable
											type={'primary'}
											icon={'fas fa-eye'}
											visible={true}
											small
											event={() => {
												this.props.setModoTela('visualizacao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
										
										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash'}
											visible={true}
											small
											event={() => {
												if (window.confirm('Deseja realmente excluir?')) {
													this.props.excluir(item);
												}
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.ideiaNegocio.modoTela,
	aguardando: state.ideiaNegocio.aguardando,
	lista: state.ideiaNegocio.lista,
	ideiaNegocioTitulo: state.texto.lista.filter(item => item.chave == 'ideiaNegocioTitulo').map(item => item.valor)[0],
	ideiaNegocioDescricao: state.texto.lista.filter(item => item.chave == 'ideiaNegocioDescricao').map(item => item.valor)[0]
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista,
	getListaTexto
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(AdmIdeiaNegocio);
